import { API_URLS } from '../../constants/urls';
import CRUDService from '../CRUDService';

class InkasatorsService extends CRUDService {
  constructor() {
    super(API_URLS.INKASATORS);
  }
}

export default new InkasatorsService();
